// extracted by css-extract-rspack-plugin
export default {"expandTriangleIcon":"SubIssuesSummaryToken-module__expandTriangleIcon__ZDWfv","SubIssuesSummaryToken":"SubIssuesSummaryToken-module__SubIssuesSummaryToken__hPS1v"};